/* Presentation only. Shopify and Tile Tools remain the quantity/price authorities. */
(function () {
  'use strict';
  function purchaseLabel(quantity, unit, total, preorder) {
    var count = Math.max(1, parseInt(quantity, 10) || 1);
    var units = unit === 'box' ? (count === 1 ? 'box' : 'boxes') : (count === 1 ? 'sheet' : 'sheets');
    return (preorder ? preorder + ' ' : 'Add ') + count + ' ' + units + (preorder ? '' : ' to cart') + ' · ' + total;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { purchaseLabel: purchaseLabel };
  if (typeof document === 'undefined') return;

  function init(root) {
    root.querySelectorAll('.PdpV2').forEach(function (product) {
      if (product.dataset.v2PdpReady) return;
      product.dataset.v2PdpReady = 'true';
      var total = product.querySelector('#pdp-total');
      function syncPurchase() {
        var button = product.querySelector('.ProductForm__AddToCart');
        var label = button && button.querySelector('[data-loading-label]');
        var amount = product.querySelector('#pdp-total-amount');
        var qty = product.querySelector('#product-quantity');
        var unit = total && total.dataset.unit;
        if (!label || button.disabled || !amount || !qty || !['box', 'sheet'].includes(unit)) return;
        var value = purchaseLabel(qty.value, unit, amount.textContent, button.dataset.preorderLabel);
        if (label.textContent !== value) label.textContent = value;
        total.classList.add('v2-pdp-total-in-button');
      }
      var observer = total ? new MutationObserver(syncPurchase) : null;
      if (observer) observer.observe(total, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-unit'] });
      product.addEventListener('variant:changed', syncPurchase);
      function selectThumbnail(event) {
        var thumb = event.target.closest('.v2-gallery-thumb');
        if (!thumb || !product.productSlideshow) return;
        var thumbs = Array.from(product.querySelectorAll('.v2-gallery-thumb'));
        product.productSlideshow.selectCell(thumbs.indexOf(thumb));
      }
      product.addEventListener('click', selectThumbnail);
      syncPurchase();
      function unload(event) {
        if (!event.target.contains(product)) return;
        if (observer) observer.disconnect();
        product.removeEventListener('variant:changed', syncPurchase);
        product.removeEventListener('click', selectThumbnail);
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
    });
    root.querySelectorAll('[data-v2-pdp-images]').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var track = gallery.querySelector('.v2-pdp-explore__track');
      var prev = gallery.querySelector('[data-v2-image-prev]');
      var next = gallery.querySelector('[data-v2-image-next]');
      function update() { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
      function move(direction) { track.scrollBy({ left: direction * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      var resize = new ResizeObserver(update); resize.observe(track); update();
      function unload(event) { if (!event.target.contains(gallery)) return; resize.disconnect(); document.removeEventListener('shopify:section:unload', unload); }
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  function samples(state) {
    if (!state) return;
    document.querySelectorAll('[data-v2-pdp-sample-count]').forEach(function (node) { node.textContent = state.totalUnits + ' of ' + state.maxSamples + ' samples selected'; });
  }
  document.addEventListener('repubblica:sample_box_changed', function (event) { samples(event.detail); });
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  function start(root) {
    init(root && root.querySelectorAll ? root : document);
    if (window.RPSampleBox) window.RPSampleBox.getState().then(samples).catch(function () {});
  }
  // The cart API is a later deferred script, so interactive still waits for DOMContentLoaded.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
